import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchContractLogs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/contract_log/list", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchStats(ctx) {
      return new Promise((resolve, reject) => {
        axios
          .get("/contract_log/stats")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
